module.exports = __webpack_public_path__ + "help_centre.085aa7f68da6061f03b71715578b45c1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/help_centre.svg
// module id = 347
// module chunks = 0